export default __webpack_public_path__ + "images/assets/019334a1dcbcdc102d6a56acc320fe2f.svg";